import { useState, useEffect } from 'react'
import { useUnit } from 'effector-react'
import { Input, Modal, Typography } from 'antd'
import {
  sendRequestToChat,
  sendRequestToChatFx,
  $sendRequestToChatPending,
} from './model'

type GoogleChatModalProps = {
  open: boolean
  onCancel: () => void
  requestUrl: string
  clientId: string
  clientEmail: string
  clientFullName: string
  managerEmail: string
}

export const GoogleChatModal = ({
  open,
  onCancel,
  requestUrl,
  clientId,
  clientEmail,
  clientFullName,
  managerEmail,
}: GoogleChatModalProps) => {
  const [question, setQuestion] = useState('')
  const loading = useUnit($sendRequestToChatPending)

  useEffect(() => {
    if (!open) {
      setQuestion('')
    }
  }, [open])

  useEffect(() => {
    const unwatch = sendRequestToChatFx.done.watch(() => {
      onCancel()
    })
    return () => unwatch()
  }, [onCancel])

  const handleSend = () => {
    sendRequestToChat({
      requestUrl,
      question,
    })
  }

  return (
    <Modal
      title="Send to Google Chat"
      open={open}
      onCancel={onCancel}
      okText="Send"
      cancelText="Cancel"
      onOk={handleSend}
      okButtonProps={{
        disabled: !question.trim(),
        loading,
        style: { backgroundColor: '#f9b115', borderColor: '#f9b115' },
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
      maskClosable={!loading}
      keyboard={!loading}
      width={600}
    >
      <Typography.Paragraph style={{ marginTop: 16 }}>
        <strong>Manager Email:</strong> {managerEmail}
      </Typography.Paragraph>
      <Typography.Paragraph>
        <strong>ClientID:</strong>{' '}
        <a href={`${window.location.origin}/client/${clientId}`} target="_blank" rel="noreferrer">
          {clientId}
        </a>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <strong>Email:</strong> {clientEmail}
      </Typography.Paragraph>
      <Typography.Paragraph>
        <strong>Fullname:</strong> {clientFullName}
      </Typography.Paragraph>

      <Input.TextArea
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        placeholder="Enter your question"
        rows={4}
        style={{ marginTop: 16 }}
      />
    </Modal>
  )
}
